import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import styles from './destination-facts-manual-travel-item.module.scss';

export interface DestinationFactsManualTravelItemProps {
  /** The class name to apply */
  className?: string;
  /** The text to show as a headline */
  headline?: string;
  /** The icon to show */
  icon?: IconName;
  /** The text to show as a pre headline */
  preHeadline?: string;
}

const DestinationFactsManualTravelItem = ({
  className,
  headline,
  icon,
  preHeadline,
}: DestinationFactsManualTravelItemProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      {icon && <Icon className={styles.icon} name={icon} size={48} />}

      {preHeadline && (
        <Typography className={styles.preHeadline} tagStyle="labelMedium">
          {preHeadline}
        </Typography>
      )}

      {headline && (
        <Typography className={styles.headline} tagStyle="headingMedium">
          {headline}
        </Typography>
      )}
    </div>
  );
};

DestinationFactsManualTravelItem.displayName =
  'DestinationFactsManualTravelItem';

export default DestinationFactsManualTravelItem;
